import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ref, onBeforeMount, onUnmounted, toRefs } from 'vue'
import { IonContent, IonPage } from "@ionic/vue";
import { useRoute, useRouter } from 'vue-router';
import ModalMessage from '@/globals/components/ModalMessage.vue';
import router from '@/router';
import { getComputedPageLayout, getIcon, IPageLayout } from '@/helpers/api';
import { useModalManager } from '@/modules/a.worksheets/services/modalManager';
import { useDeviceStatus } from '@/stores/deviceStatus';


interface _1616B extends IPageLayout {
    labels: {
        title: string,
        lines: Array<string>
        button: string
    }
    icons: {icon: string}
    commands: {
        router: string
    }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NewSolutionThanksModal',
  setup(__props) {

const { isWeb } = toRefs(useDeviceStatus());


const icon = ref<string>()
const layout = getComputedPageLayout<_1616B>('1616B')
onBeforeMount(async () => {
    icon.value = await getIcon('1616B', 'icon')
})

const modalManager = useModalManager()
function routeAway(){
    if(layout.value){
        router.push(layout.value.commands.router)
        modalManager.close('btn click')
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb)
      }, {
        default: _withCtx(() => [
          (_unref(layout))
            ? (_openBlock(), _createBlock(ModalMessage, {
                key: 0,
                icon: icon.value,
                title: _unref(layout)?.labels.title,
                button: {textContent: _unref(layout).labels.button, danger: false},
                description: _unref(layout).labels.lines,
                onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (routeAway()))
              }, null, 8, ["icon", "title", "button", "description"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})